import Configuration from './Configuration.page';

export default Configuration;
